<script setup>
    import { useI18n } from 'vue-i18n';
    const { t } = useI18n();

    const props = defineProps({
        downloadFiles: {
            type: Object,
            required: true,
        },
    });

    function showDropDown(event) {
        let currentDropdownOption = event.target.nextSibling;
        if(currentDropdownOption !== undefined){
            if(currentDropdownOption.classList.contains('dropdown-content')){
                if(!currentDropdownOption.classList.contains('is-hidden')) {
                    currentDropdownOption.classList.add('is-hidden');
                } else {
                    currentDropdownOption.classList.remove('is-hidden');
                }
            }
        }
    }

    function closeDropDown(event){
        let dropDownOption = event.target.parentElement;
        if(dropDownOption !== undefined){
            if(dropDownOption.classList.contains('dropdown-content')){
                if(!dropDownOption.classList.contains('is-hidden')) {
                    dropDownOption.classList.add('is-hidden');
                } else {
                    dropDownOption.classList.remove('is-hidden');
                }
            }
        }
    }
</script>

<style lang="scss">
@import "../../../../scss/variables";
    .dropdown {
      position: relative;
      display: inline-block;
      width: 100%;
      margin-top: -10px;
    }

    .dropdown-button {
      width: 100%;
      padding: 1rem;
      border: 1px solid ;
      border-color: rgba(70,85,95,.24);
      cursor: pointer;
      background-color: $white;
      text-align:left;
    }

    .dropdown-button:after{
        border: 3px solid $secondary;
        border-radius: 2px;
        border-right: 0;
        border-top: 0;
        content: " ";
        display: block;
        height: .625em;
        margin-top: -.4375em;
        pointer-events: none;
        position: absolute;
        top: 50%;
        transform: rotate(-45deg);
        transform-origin: center;
        width: .625em;
        right: 1rem;
        z-index: 4;
    }

    .dropdown-content {
      position: absolute;
      background-color: $white-ter;
      min-width: 100%;
      box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
      z-index: 1;
    }

    .dropdown-content a {
      color: $black;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    .dropdown-content a:hover {
      background-color: $primary;
    }

    .icon-download {
      width: 20px;
      height: 20px;
      float:right
    }

</style>

<template>
      <div class="dropdown" @click="showDropDown($event)">
            <button class="dropdown-button">Download</button>
            <div class="dropdown-content is-hidden">
                  <a v-for="(lang, index) in props.downloadFiles" :key="index" download class="dropdown-language" :href="lang.url" target= "_blank" @click="closeDropDown($event)">
                        {{ t("productHero.Download.Language." + lang.language) }}
                        <svg class="icon icon-download">
                            <use xlink:href="#icon-download-2023"/>
                        </svg>
                  </a>
            </div>
      </div>
</template>
